const MapDataSource = {
	// Satellite imagery
	SATELLITE_TILES: "mapbox://mapbox.satellite",

	// Map Data
	TTW_AREAS: "ttw_areas",
	TZ_AREAS: "traffic_zone_areas",
	ROI_AREAS: "roi_areas",

	// Environment
	ENVIRONMENT_LINES: "environment_lines",
	ENVIRONMENT_LABELS: "environment_labels",

	// Measure
	MEASURE_POINTS: "measure_points",
	MEASURE_POINT_LINES: "measure_points_lines",
	MEASURE_LABELS: "measure_labels",

	// Measure
	ROUTEPLOT_POINTS: "routeplot_points",
	ROUTEPLOT_POINT_LINES: "routeplot_points_lines",
	ROUTEPLOT_LABELS: "routeplot_labels",

	// Alerts
	LIVE_VESSELS: "live_vessels",
	HISTORIC_LINES: "historic_lines",
	HISTORIC_POINTS: "historic_points",
	VESSELS_LIVE_NEARBY_BOUNDS: "vessels-live-nearby-bounds",

	// Vessel History Query
	FLEET_HISTORY: "fleet_history",
	FLEET_HISTORY_LINES: "fleet_history_lines",
	HIGHLIGHT_LINES: "highlight_lines",
	HISTORIC_SNAPSHOT: "historic_snapshot",

	AIRCRAFT_FAKE_LIVE: "aircraft_fake_live",
	AIRCRAFT_FAKE_HISTORIC_LINES: "aircraft_fake_historic_lines",
	AIRCRAFT_FAKE_HISTORIC_POINTS: "aircraft_fake_historic_points",

	AIRCRAFT_ALERTS: "aircraft_alerts_live",
	AIRCRAFT_ALERTS_LINES: "aircraft_alerts_lines",
	AIRCRAFT_ALERTS_POINTS: "aircraft_alerts_points",

	AIRCRAFT_HISTORY_LINES: "aircraft_history_lines",
	AIRCRAFT_HISTORY_POINTS: "aircraft_history_points",
	AIRCRAFT_HISTORY_SNAPSHOT: "aircraft_history_snapshot",

	SANCTIONS_POLYGONS: "sanctions_polygons",
	VESSEL_FOCUSED: "vessel_focused",

	TIMEZONE: "timezone_overlay",
	TIMEZONE_LABELS: "timezone_labels",

	CUSTOM_GEOJSON_FILLS: "custom_geojson_fills",
	CUSTOM_GEOJSON_LINES: "custom_geojson_lines",

	CUSTOM_DRAW_LINES: "draw-polyline-lines",
	CUSTOM_DRAW_LINES_POINTS: "draw-polyline-points",
	CUSTOM_DRAW_LINES_FILLS: "draw-polyline-fills",

	SANCTIONS: "sanctions",

	VESSELS_NEARBY: "vessels_nearby",
	VESSELS_NEARBY_LINES: "vessels_nearby_lines",

	MDA_SATCAP: "mda_satcap",

	NATIONALGRID_UNDERSEA_CABLE_LINES: "ng_undersea_cable_lines",
	NATIONALGRID_UNDERSEA_CABLE_BUFFERS: "ng_undersea_cable_buffers",
	NATIONALGRID_UNDERSEA_CABLE_POINTS: "ng_undersea_cable_points",

	CLEOS_SATRF_VESSELS: "cleos_satellite_rf_vessels",
	CLEOS_SATRF: "cleos_satellite_rf"

};
export default MapDataSource;
